import React, { useState, useMemo } from 'react';
import moment from 'moment';
import MUIDataTable from 'mui-datatables';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';

const ReturnOrdersTable = (props) => {

  const [rowsExpanded, setRowsExpanded] = useState([]);

  const tableData = useMemo(() => {
    const initialTableData = [];

    for ( let i = 0; i < props.returnOrders.length; i++ ) {
      const returnOrder = props.returnOrders[i];
      const returnOrderVendor = props.vendors.find(vendor => vendor.id === returnOrder.vendorId);
      initialTableData.push({
        id: returnOrder.id,
        displayId: returnOrder.displayId,
        name: returnOrderVendor.name,
        products: returnOrder.products,
        total: returnOrder.total,
        createdAt: moment(returnOrder.createdAt).format('DD/MM/YYYY')
      });
    }

    return initialTableData;
    
  }, [props.returnOrders, props.vendors]);

  const onRowExpansionChange = (currentRowsExpanded, allRowsExpanded) => {
    setRowsExpanded(allRowsExpanded.map(row => row.dataIndex));
  };

  const columns = [
    { label: "ID", name: "id", options: { display: 'excluded', filter: false, sort: false, viewColumns: false } },
    { label: "R.O. ID", name: "displayId" },
    { label: "Vendors Name", name: "name"},
    { label: "R.O. Amount", name: "total" },
    { label: "Return Date", name: "createdAt" }
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'standard',
    rowsExpanded,
    onRowExpansionChange,
    selectableRows: 'none',
    expandableRows: true,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    isRowExpandable: (dataIndex, expandedRows) => {
      // Prevent expand/collapse of any row if there are 3 rows expanded already (but allow those already expanded to be collapsed)
      if (expandedRows.data.length > 3 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0)
        return false;
      return true;
    },
    renderExpandableRow: (rowData, rowMeta) => {
      const colSpan = rowData.length + 1;
      const returnOrderId = rowData[0];
      const rowProducts = tableData.find(returnOrder => returnOrder.id === returnOrderId).products;
      return (
        <tr>
          <td colSpan={colSpan}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Product ID</TableCell>
                    <TableCell>Product Name</TableCell>
                    <TableCell>Product Brand</TableCell>
                    <TableCell>Unit Cost</TableCell>
                    <TableCell>Quantity</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rowProducts.map((rowProduct) => {
                    const productInfo = props.products.find(product => product.id === rowProduct.productId);
                    return (
                      <TableRow key={productInfo ? productInfo.displayId : Math.floor(Math.random() * 1000).toString()}>
                        <TableCell>
                          {productInfo ? productInfo.displayId : ""}
                        </TableCell>
                        <TableCell>{productInfo ? productInfo.name : ""}</TableCell>
                        <TableCell>{productInfo ? productInfo.company : ""}</TableCell>
                        <TableCell>{productInfo ? productInfo.unitCost : ""}</TableCell>
                        <TableCell>{rowProduct.quantity}</TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </td>
        </tr>
      );
    }
  };

  return(
    <MUIDataTable 
      title={"Return Orders"}
      data={tableData}
      columns={columns}
      options={options}
    />
  )
};

export default ReturnOrdersTable;